import type { LevelRequirement, LevelRequirementType } from './types'

export function assertRequirementType<T extends LevelRequirementType>(
  requirement: LevelRequirement,
  type: T
): asserts requirement is LevelRequirement & { type: T } {
  if (requirement.type !== type) {
    throw new Error(`Expected '${type}', got ${requirement.type}`)
  }
}
